import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { Permissions } from '@utils/constants/permissions';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const useCrmFacebookExpired = (props?: { onSuccess: (data: crmModels.ICrmFacebookExpired) => void }) => {
  const permissions = useAppSelector(({ userReducer: { user } }) => user?.role?.permissions);

  const isAccess = permissions?.includes(Permissions.PERMISSION_SETTINGS_CRM);

  return useQuery<crmModels.ICrmFacebookExpired>({
    queryKey: [crmConstants.queryKeys.CRM_FACEBOOK_EXPIRED],
    queryFn: async () => {
      const res = await $api.get('/v1/crm/facebook/expired');

      return res?.data?.data;
    },
    enabled: isAccess,
    onSuccess: data => props?.onSuccess(data)
  });
};
